/* eslint-disable @nx/enforce-module-boundaries */
import { SelectItem } from '@heitown/frontend-common';
import { FieldType } from './field-type.enum';

export interface FieldConfig {
  // per export
  name: string;
  label: string;
  type: FieldType;
  elementValues?: SelectItem[];
  hidden?: boolean;
}
